import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ImagesSlide = Scrivito.provideObjClass("ImagesSlide", {
  attributes: {
    backgroundImage: ["reference", { only: ["Image"] }],
    body: "html",
    images: ["referencelist", { only: ["Image"] }],
    sortKey: "integer",
    smallHeader: "string",
    targetLink: "link",
    ...defaultPageAttributes,
    ...metadataAttributes,
  },
});

export default ImagesSlide;
